export class prospect{
    Personguid: string;
    SilUnsubscribeType: SilUnsubscribeType;
}

export enum SilUnsubscribeType{
    SilProspectConsent = 1
}

export interface UserPreferences{
    EmailAddress:string;
    Status: boolean;
    IsUserFound: boolean;
}